import React, { useState, useEffect } from 'react';
import { Drawer } from 'antd';

const CustomDrawer = ({ children, width = 600, ...props }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <style>{`
        .custom-drawer-right-close .ant-drawer-header-title {
          flex-direction: row-reverse;
          justify-content: space-between;
        }
        .custom-drawer-right-close .ant-drawer-close {
          margin-inline-end: 0 !important;
          margin-inline-start: 12px !important;
        }
      `}</style>
      <Drawer
        className="custom-drawer-right-close"
        placement={isMobile ? 'bottom' : 'right'}
        width={isMobile ? '100%' : width}
        height={isMobile ? '80vh' : '100%'}
        style={{
          borderTopLeftRadius: isMobile ? 16 : 0,
          borderTopRightRadius: isMobile ? 16 : 0,
        }}
        {...props}
      >
        {children}
      </Drawer>
    </>
  );
};

export default CustomDrawer;
